module.exports = __webpack_public_path__ + "img/company-logo-background-small.26ba799c.svg";